import { Injectable } from '@angular/core';

/**
 * This service stores the jwt we use to authenticate the requests to the backend.
 * It is needed to inject it in image URLs
 */
@Injectable()
export class JWTService {
  public readonly JWT_HEADER_AND_PARAM_NAME = 'x-inmessage-jwt';
  private jwt: string;

  constructor() {
    // Give priority to a JWT passed in by the MBR from the parent page to our iframe
    // (it probably comes from a link to the parent page from an email)
    const urlParams = new URLSearchParams(window.location.search);
    this.jwt = urlParams.get(this.JWT_HEADER_AND_PARAM_NAME);
    if (this.jwt) {
      console.log(`inmessage - jwt from URL: ${this.jwt}`);
    } else {
      // If not, let's give the localstorage a chance.
      // We don't use cookies any more, as iOS Safari
      // refuses to set cookies from an iframe
      // if it has never navigated to the domain before
      // (but curiously enough, local storage is allowed...)
      try {
        this.jwt = localStorage.getItem(this.JWT_HEADER_AND_PARAM_NAME);
        console.log(`inmessage - jwt from localstorage: ${this.jwt}`);
      } catch (e) {
        console.log('inmessage - access to localstorage denied');
      }
    }
  }

  public hasJwt(): boolean {
    return !!this.getJwt();
  }

  public getJwt(): string {
    return this.jwt;
  }

  public setJwt(jwt: string) {
    console.log('inmessage - setting jwt to ' + jwt);
    this.jwt = jwt;
    try {
      localStorage.setItem(this.JWT_HEADER_AND_PARAM_NAME, jwt);
    } catch (e) {
      console.log('inmessage - access to localstorage denied');
    }
  }
}
